export default __webpack_public_path__ + "static/media/8.ac977ed6.jpg";